<template>
  <v-container>
    <v-layout row v-show="errorMessage">
      <v-flex xs12>
        <app-alert @dismissed="onDismissed" :msg="errorMessage" type="error" />
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-container>
              <div class="header">
                <img class="mb-4" src="../assets/YourVoiceCoach_logo-smaller.jpg" alt="Your Voice Coach">
                <h1 class="mb-4 ml-2">Student sign in</h1>
              </div>
              <form @submit.prevent="onSignIn">
                <v-text-field label="Your email address" id="email" type="email" v-model.trim="email" required>
                </v-text-field>

                <div v-show="pwd != ''" class="show" @click="switchVisibility">Show password</div>

                <v-text-field class="mb-4" label="Your password" id="pwd" :type="passwordFieldType" v-model.trim="pwd" required>
                </v-text-field>

                <v-btn small type="submit" :disabled="loading" :loading="loading" class="secondary mr-4 mb-4">Sign in
                  <span slot="loader" class="custom-loader">
                    <v-icon light>cached</v-icon>
                  </span>
                </v-btn>
              </form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>ß

<script>
export default {
  mounted() {
    this.$store.commit('clearUser')
    this.email = ""
    this.password = ""
    document.getElementById('email').focus()
  },
  data() {
    return {
      email: "",
      pwd: "",
      passwordFieldType: "password",
      alert: true
    }
  },
  computed: {
    errorMessage() {
      return this.$store.getters.getError
    },
    loading() {
      return this.$store.getters.loading
    }
  },
  methods: {
    onSignIn() {
      const user = {
        email: this.email,
        password: this.pwd
      };
      this.$store.dispatch("signIn", user)
    },
    onDismissed() {
      this.$store.commit("clearError")
    },
    switchVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password"
      setTimeout(() => {
        this.passwordFieldType = "password"
      }, 1000)
    }
  }
};
</script>

<style scoped>
.container {
  padding: 5px;
}

.header{
  display: inline-flex;
  flex-direction: column;
  justify-content: baseline;
  font-size: 1em;
}

img {
  max-width:100%;
  height:auto;
  }

.show {
  font-size: 11px;
  text-decoration: underline;
  margin-bottom: 20px;
  margin-top: 10px;
}
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>